"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.darkDefaults = void 0;
var palette_1 = __importDefault(require("./palette"));
var dark_defaults_1 = require("./dark-defaults");
Object.defineProperty(exports, "darkDefaults", { enumerable: true, get: function () { return dark_defaults_1.darkDefaults; } });
exports.default = palette_1.default;
